import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19283 17130"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:279.465}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970281540768">
        <path
          d="M1407 140c700 0 1268 567 1268 1267s-567 1267-1268 1267c-700 0-1267-567-1267-1267S707 140 1407 140zM1407 4912c700 0 1268 567 1268 1267s-567 1268-1268 1268c-700 0-1267-567-1267-1268 0-700 567-1267 1267-1267zM5524 140c700 0 1268 567 1268 1267s-567 1267-1268 1267c-700 0-1267-567-1267-1267S4824 140 5524 140zM5524 4912c700 0 1268 567 1268 1267s-567 1268-1268 1268c-700 0-1267-567-1267-1268 0-700 567-1267 1267-1267zM5524 9683c700 0 1268 568 1268 1268 0 699-567 1267-1268 1267-700 0-1267-568-1267-1267 0-700 567-1268 1267-1268zM9641 140c700 0 1268 567 1268 1267s-568 1267-1268 1267-1268-567-1268-1267c1-700 568-1267 1268-1267zM9641 4912c700 0 1268 567 1268 1267s-568 1268-1268 1268-1268-567-1268-1268c0-700 568-1267 1268-1267zM9641 9683c700 0 1268 568 1268 1268 0 699-568 1267-1268 1267s-1268-568-1268-1267c1-700 568-1268 1268-1268zM9641 14455c700 0 1268 567 1268 1267s-568 1268-1268 1268-1268-568-1268-1268c1-700 568-1267 1268-1267zM13759 140c699 0 1268 567 1268 1267s-568 1267-1268 1267-1268-567-1268-1267c-1-700 567-1267 1268-1267zM13759 4912c699 0 1268 567 1268 1267s-568 1268-1268 1268-1268-567-1268-1268c0-700 567-1267 1268-1267zM13759 9683c699 0 1268 568 1268 1268 0 699-568 1267-1268 1267s-1268-568-1268-1267c-1-700 567-1268 1268-1268zM17875 140c700 0 1268 567 1268 1267s-567 1267-1268 1267c-700 0-1267-567-1267-1267s567-1267 1267-1267zM17875 4912c700 0 1268 567 1268 1267s-567 1268-1268 1268c-700 0-1267-567-1267-1268 0-700 567-1267 1267-1267z"
          className="fill stroke1s"
          style={{
            strokeWidth: 279.465,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
